<template>
  <main class="container container-choose-route d-flex flex-column align-items-center">
    <CustomerRegisterComponent></CustomerRegisterComponent>
  </main>
</template>

<script type="ts">
import CustomerRegisterComponent from "../../components/CustomerRegistration/CustomerRegistrationComponent";
import '../logInPage/logIn.scss';
import axios from "axios";
import apiService from "../../services/apiService";
import {useStore} from "vuex";
import {defineComponent} from "vue";

export default defineComponent({
  name: "RegisterPage",
  components: {
    CustomerRegisterComponent
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {}
  },
  methods: {},
  created() {
    axios.get(apiService.pageRegisterPageEndpoint())
        .then((response) => {})
        .catch(error => console.error(error));
  },
});
</script>